import axios from 'axios';
import { publicIpv4 } from 'public-ip';
import Toast from 'react-simple-toasts';
import { Constant } from '../constant';

export const displayConsole = (key, value) => {
    // console.log(key,value)
};

export const showAppToast = (message, timeOutDuration) => {
    if (message) {
        if (timeOutDuration) {
            Toast(message, timeOutDuration);
        } else {
            Toast(message);
        }
    }
    // setTimeout(function () {
    //     Toast.showWithGravity(message, Constant.App.ToastTime.LongTime, Toast.TOP);
    // }, timeOutDuration)
};

export const sendRequest = (payload) => {
    let requestPay = {
        url: Constant.App.ServerUrl + payload.url,
        type: payload.type
    };

    if (payload.hasOwnProperty("data")) {
        requestPay.data = payload.data
    }
    return axios(requestPay)
}

export const getPublicIp = async () => {
    // return "73.118.205.232"; // Seth IP
    // return "173.175.214.222"; // Taylor IP
    // return "14.194.152.42"; // MSS IP (1)
    // return "125.20.112.42"; // MSS IP (2)
    // return "203.12.12.12"; // Random IP
    return await publicIpv4()
}

export const AUDIO_CHANNEL_MODE = ["Mono", "Mono-in/Stereo-out", "Stereo"];